import { createStore } from 'vuex'
import user from './modules/user'
import wallet from './modules/wallet'


const store = createStore({
    modules: {
        user,
        wallet

    },
    strict: process.env.NODE_ENV !== 'production'
})

export default store